export function minAndMaxDate(this, minDate?: Date, maxDate?: Date) {
  const validateFn = (control) => {
    if (!this.form) {
      // skips until the form is ready
      return null;
    }

    if (!minDate) minDate = new Date('01/01/1950');
    if (!maxDate) maxDate = new Date('01/01/2999');

    if (minDate > control.value) {
      return { min: true };
    }
    if (control.value > maxDate) {
      return { max: true };
    }

    return null; // No error if did not return one
  };

  return validateFn;
}

export function resetBadRawDateInput(this, formControlName, rawInput) {
  // Require raw input to be 10 characters
  if (rawInput.value.length < 8 && !(rawInput.value.length === 0)) {
    this.form.controls[formControlName].setValue(null);
  }

  // Prevents another weird behavior of 'new Date()'
  if (rawInput.value.includes('(')) {
    this.form.controls[formControlName].setValue(null);
  }

  // Require raw input to be parsable by default Date parser
  if (new Date(rawInput.value).toString() === 'Invalid Date') {
    this.form.controls[formControlName].setValue(null);
  }
}
